import styled from "styled-components";
import { MOBILE } from "../../constants/breakpoints";
import colors from "../../constants/colors";

interface IContainerProps {
    gap?: string
}
export const Container = styled.section<IContainerProps>`
    display: flex;
    margin-top: 40px;
    border: 1px solid #ccc4b3;
    border-radius: 12px;
    padding: 32px;
    flex-direction: column;
    gap: ${(props: IContainerProps) => props.gap ?? '0'};
    @media (max-width: ${MOBILE}px) {
        width: 100%;
        height: max-content;
        padding: 16px 24px;
    }
`
export const LoaderContainer = styled.div`
    width: 100%;
    justify-content: center;
    display: flex;
    .loader {
        width: 48px;
        height: 48px;
        display: inline-block;
        position: relative;
        border: 3px solid;
        border-color: ${colors.INTERFACE_COLORS_LAVABEE_YELLOW} #0000 ${colors.INTERFACE_COLORS_BASALT} #0000;
        border-radius: 50%;
        box-sizing: border-box;
        animation: 1s rotate linear infinite;
    }
    .loader:before , .loader:after{
        content: '';
        top: 0;
        left: 0;
        position: absolute;
        border: 10px solid transparent;
        border-bottom-color: ${colors.INTERFACE_COLORS_BASALT};
        transform: translate(-10px, 19px) rotate(-35deg);
    }
    .loader:after {
        border-color: ${colors.INTERFACE_COLORS_LAVABEE_YELLOW} #0000 #0000 #0000 ;
        transform: translate(32px, 3px) rotate(-35deg);
    }
    @keyframes rotate {
        100%{transform: rotate(360deg)}
    }
`